module.exports = __webpack_public_path__ + "static/media/en-data-roaming-iphone_3.7a9f5cf4.png";